import { getComments } from "./getComments";

export const getPcms = (pcmData) => {

    let jiraTasks = pcmData.jiraTickets;
    let pTasks = pcmData.pTasks;
    let comments = getComments(pcmData.comments, "PCM COMMENTS");
  
    return [
      { jira: [...jiraTasks], ptask: [...pTasks], comments: [...comments] },
    ];
  };